import React from 'react';
import './PC.css';
import Accenture from '../../img/pc/Accenture.png'
import Benniks from '../../img/pc/Benniks.png'
import Gomes from '../../img/pc/Gomes.png'
import Siejczuk from '../../img/pc/Siejczuk.png'
import Uniform from '../../img/pc/Uniform.png'
import Valtec from '../../img/pc/Valtec.png'
import ElasticPath from '../../img/pc/ElasticPath.png'
import Luterek from '../../img/pc/Luterek.png'
import Rakowski from '../../img/pc/Rakowski.png'
import VueStorefront from '../../img/pc/VueStorefront.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Benniks,
          name: 'Tim Benniks',
          position: 'Director of Developer Relations ',
          ln: 'https://www.linkedin.com/in/timbenniks/',
          tw: 'https://twitter.com/timbenniks',
          logo: Uniform,
        },
        {
          photo: Gomes,
          name: 'Rafael Corrêa Gomes',
          position: 'Adobe Solution Architect at Valtech',
          ln: 'https://www.linkedin.com/in/rafaelcgstz/',
          tw: 'https://twitter.com/rafaelcgstz',
          logo: Valtec,
        },
        {
          photo: Siejczuk,
          name: 'Piotr Siejczuk',
          position: 'eCommerce Solutions Architect',
          ln: 'https://www.linkedin.com/in/piotrsiejczuk/',
          tw: 'https://twitter.com/PiotrSiejczuk',
          logo: Accenture,
        },
        {
          photo: Luterek,
          name: 'James Luterek',
          position: 'Head of Developer Relations',
          ln: 'https://www.linkedin.com/in/jamesluterek/',
          youtube: 'https://www.youtube.com/jamesluterek',
          logo: ElasticPath,
        },
        {
          photo: Rakowski,
          name: 'Filip Rakowski',
          position: 'CTO / Co-founder',
          ln: 'https://www.linkedin.com/in/filip-rakowski-a43671129/',
          tw: 'https://twitter.com/filrakowski',
          logo: VueStorefront,
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Program committee</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}